import React from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import Button from "components/Button";
import Table from "components/Table";
import FieldChooser from "components/FieldChooser";
import TopButtons from "components/TopButtons";
import { IAccountStatement, IMeta, ICommonState } from "models/.";
import { connect } from "../../reduxConnector";
import AccountStatementsActions from "./actions";
import { columns } from "./columns";
import RangeDatepicker from "components/RangeDatepicker";
import DetailView from "components/DetailView";
import FilterGenerator from "helpers/filter";
import { downloadExcel } from "./downloadExcel";
import { markAsRead, markAsUnread } from "../app/actions";
import { downloadDocuments } from "helpers/download";
import { getSelectedData } from "helpers/common";
import { CUSTOM_SETTINGS } from "constants/.";

import "./style.scss";

interface IProps {
  getAccountStatements: (meta?: IMeta) => void;
  accountStatements: IAccountStatement[];
  meta: IMeta;
}

interface IState extends ICommonState {
  paymentDate: any;
  selectedData: any;
}

class AccountStatements extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: "",
      showFieldChooser: false,
      columnsCopy: [],
      paymentDate: {},
      checkedRows: {},
      selectedData: []
    };
  }

  public componentDidMount() {
    this.props.getAccountStatements();
  }

  public handleSelect = selectedOption => {
    const { checkedRows, selectedData } = this.state;
    const { value } = selectedOption;
    const ids = _(checkedRows)
      .keys()
      .map(_.toNumber)
      .value();

    value === "gelezen" && markAsRead(ids, "RekeningOverzicht");
    value === "ongelezen" && markAsUnread(ids, "RekeningOverzicht");
    if (value === "pdf") {
      const documentIds = _.compact(_.map(selectedData, "documentId"));
      downloadDocuments(documentIds, "ACCOUNT_STATEMENTS");
      markAsRead(ids, "RekeningOverzicht");
    }
  };

  public handleFieldChooser = () => {
    this.setState(({ showFieldChooser }) => ({
      showFieldChooser: !showFieldChooser
    }));
  };

  public handleFieldsChange = data => {
    this.setState({ columnsCopy: data });
  };

  public handleFilterChange = (value, name) => {
    const paymentDate = _.cloneDeep(this.state.paymentDate);

    _.set(paymentDate, name.split(".")[1], value);
    this.setState({ paymentDate });
  };

  public resetFilter = () => {
    const { getAccountStatements, meta } = this.props;
    this.setState({ paymentDate: {} }, () =>
      getAccountStatements({
        ...meta,
        searchString: "",
        currentPage: 0,
        filter: this.state.paymentDate
      })
    );
  };

  public generateFilter = () => {
    const { getAccountStatements, meta } = this.props;
    const Q = new FilterGenerator();
    const paymentDate = _.cloneDeep(this.state.paymentDate);

    Q.without("PaymentDate", paymentDate, "dateRange");
    getAccountStatements({
      ...meta,
      searchString: Q.query,
      currentPage: 0,
      filter: paymentDate
    });
  };

  private onRowSelect = checkedRows => {
    this.setState({
      checkedRows,
      selectedData: getSelectedData(
        this.props.accountStatements,
        checkedRows,
        this.state.selectedData
      )
    });
  };

  public render() {
    const { getAccountStatements, accountStatements, meta } = this.props;
    const {
      showFieldChooser,
      columnsCopy,
      selectedOption,
      paymentDate,
      checkedRows
    } = this.state;
    const date = _.isEmpty(paymentDate) ? meta.filter : paymentDate;

    return (
      <div id="account-statements-page">
        <FormattedMessage id="ACCOUNT_STATEMENTS" tagName="h1" />
        <DetailView>
          <div className="search-bar">
            <RangeDatepicker
              name="paymentDate"
              label="ACCOUNT_STATEMENTS_SEARCH"
              value={date}
              handleRangeChange={this.handleFilterChange}
              dateClassName="search-datepicker"
            />
            <div className="search-btn">
              <Button onClick={this.resetFilter}>RESET</Button>
              <Button
                kind="primary"
                onClick={this.generateFilter}
                disabled={_.isEmpty(date)}
              >
                SEARCH
              </Button>
            </div>
          </div>
        </DetailView>
        <TopButtons
          switchUnread={meta.unread}
          handleFieldChooser={this.handleFieldChooser}
          handleSelect={this.handleSelect}
          toggleUnread={() =>
            getAccountStatements({
              ...meta,
              unread: !meta.unread,
              currentPage: 0
            })
          }
          selectedOption={selectedOption}
          downloadExcel={downloadExcel}
          getExcelData={() =>
            AccountStatementsActions.getExportData(meta.searchString)
          }
          entityName="account-statements"
        />
        <Table
          columns={columnsCopy}
          dataSource={accountStatements}
          meta={meta}
          onQueryChange={getAccountStatements}
          onRowSelect={this.onRowSelect}
          checkedRows={checkedRows}
          pageName={CUSTOM_SETTINGS.accountStatements}
        />
        <FieldChooser
          name="rekeningoverzichten"
          visible={showFieldChooser}
          handleFieldChooser={this.handleFieldChooser}
          handleFieldsChange={this.handleFieldsChange}
          columns={columns}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    accountStatements: state.accountStatements.items,
    meta: state.accountStatements.meta
  }),
  { getAccountStatements: AccountStatementsActions.getAccountStatements }
)(AccountStatements);
